// Product catalog data for Burj Al Qamar Trading F.Z.E.
// AI-generated professional product photography served from the backend
// under /api/static/products/*.png

const API = process.env.REACT_APP_BACKEND_URL || "";
const IMG = (name) => `${API}/api/static/products/${name}.png`;

// AI-photographed product plates
export const IMAGES = {
  hero: IMG("hero"),
  paperCups: IMG("paper-cups"),
  paperCupsWhite: IMG("paper-cups-white"),
  kraftContainer: IMG("kraft-container"),
  kraftTakeaway: IMG("kraft-takeaway"),
  kraftBowl: IMG("kraft-bowl"),
  sandwichBox: IMG("sandwich-box"),
  paperBag: IMG("paper-bag"),
  sosBag: IMG("sos-bag"),
  aluminiumContainer: IMG("aluminium-container"),
  aluminiumFoil: IMG("aluminium-foil"),
  woodenCutlery: IMG("wooden-cutlery"),
  hygieneGloves: IMG("hygiene-gloves"),
  hygieneMasks: IMG("hygiene-masks"),
  plasticMicrowave: IMG("plastic-microwave"),
  plasticClear: IMG("plastic-clear"),
};

const P = IMAGES;

export const CATEGORIES = [
  {
    id: "paper",
    index: "01",
    kicker: "Chapter One",
    title: "Paper",
    subtitle: "Kraft. Coated. Considered.",
    blurb:
      "From ripple-wall coffee cups to SOS carry bags — a full architecture of paper packaging engineered for hot food, cold drinks and takeaway service.",
    image: P.paperCups,
    items: [
      { n: "02", name: "Kraft Paper Cups", img: P.paperCups },
      { n: "03", name: "Kraft Sauce Cups", img: P.paperCupsWhite },
      { n: "03", name: "Kraft Containers", img: P.kraftContainer },
      { n: "03", name: "Kraft Square Box", img: P.sandwichBox },
      { n: "04", name: "Kraft Salad Bowl", img: P.kraftBowl },
      { n: "04", name: "Kraft Sandwich Boxes", img: P.sandwichBox },
      { n: "05", name: "Kraft Soup / Noodle Bowl", img: P.kraftBowl },
      { n: "05", name: "Kraft Window Box", img: P.kraftContainer },
      { n: "04", name: "Kraft Boat Trays", img: P.kraftTakeaway },
      { n: "06", name: "Kraft Takeaway Box", img: P.kraftTakeaway },
      { n: "08", name: "Paper Carry Bags", img: P.paperBag },
      { n: "10", name: "Paper SOS Bags", img: P.sosBag },
      { n: "09", name: "Paper Bags & Pouches", img: P.paperBag },
      { n: "12", name: "Paper Cups", img: P.paperCupsWhite },
    ],
  },
  {
    id: "aluminium",
    index: "02",
    kicker: "Chapter Two",
    title: "Aluminium",
    subtitle: "Heat. Hold. Deliver.",
    blurb:
      "Foil-wrapped, oven-ready. Round, rectangular and platter formats engineered for catering, cloud kitchens and airline service.",
    image: P.aluminiumContainer,
    items: [
      { n: "15", name: "Aluminium Foil", img: P.aluminiumFoil },
      { n: "17", name: "Aluminium Round Containers", img: P.aluminiumContainer },
      { n: "16", name: "Aluminium Rectangular Containers", img: P.aluminiumContainer },
      { n: "17", name: "Aluminium Platter", img: P.aluminiumContainer },
    ],
  },
  {
    id: "wooden",
    index: "03",
    kicker: "Chapter Three",
    title: "Wooden",
    subtitle: "Grain. Grown. Gone.",
    blurb:
      "Birch-wood cutlery, stirrers, chopsticks and toothpicks — biodegradable, splinter-free and finished with a paper-smooth feel.",
    image: P.woodenCutlery,
    items: [
      { n: "19", name: "Coffee Stirrer", img: P.woodenCutlery },
      { n: "19", name: "Chopstick", img: P.woodenCutlery },
      { n: "19", name: "Toothpick", img: P.woodenCutlery },
      { n: "20", name: "Wooden Cutleries", img: P.woodenCutlery },
    ],
  },
  {
    id: "hygiene",
    index: "04",
    kicker: "Chapter Four",
    title: "Hygiene",
    subtitle: "The invisible standard.",
    blurb:
      "Barrier essentials for foodservice, healthcare and clean production lines — gloves, masks, aprons, hair & beard covers.",
    image: P.hygieneGloves,
    items: [
      { n: "22", name: "Gloves", img: P.hygieneGloves },
      { n: "24", name: "Plastic Apron", img: P.hygieneMasks },
      { n: "23", name: "Face Masks", img: P.hygieneMasks },
      { n: "23", name: "Hair Net", img: P.hygieneMasks },
      { n: "24", name: "Beard Cover", img: P.hygieneMasks },
    ],
  },
  {
    id: "plastic",
    index: "05",
    kicker: "Chapter Five",
    title: "Plastic",
    subtitle: "Engineered for the long haul.",
    blurb:
      "Microwave-safe blackbase, clear containers, cutlery, cling & stretch films, sofra, zipper bags and waste sacks — a full-spectrum system.",
    image: P.plasticMicrowave,
    items: [
      { n: "26", name: "Blackbase HD Microwave Rectangle Container", img: P.plasticMicrowave },
      { n: "27", name: "Blackbase HD Microwave Round Container", img: P.plasticMicrowave },
      { n: "27", name: "Black Base Microwave Container", img: P.plasticMicrowave },
      { n: "28", name: "Sushi Containers", img: P.plasticClear },
      { n: "28", name: "Clear Containers", img: P.plasticClear },
      { n: "29", name: "Microwave Rectangle Container", img: P.plasticMicrowave },
      { n: "30", name: "Microwave Round Container", img: P.plasticMicrowave },
      { n: "31", name: "Plastic Clear Juice Cups", img: P.plasticClear },
      { n: "31", name: "Plastic Cutleries", img: P.woodenCutlery },
      { n: "32", name: "Cling Film", img: P.plasticClear },
      { n: "32", name: "Sofra", img: P.plasticClear },
      { n: "33", name: "Stretch Wrap Film", img: P.plasticClear },
      { n: "33", name: "Zipper Bags", img: P.plasticClear },
      { n: "34", name: "Dustbin Bags", img: P.paperBag },
      { n: "34", name: "Garbage Bags", img: P.paperBag },
      { n: "35", name: "Plastic Carry Bags", img: P.paperBag },
    ],
  },
];

// Curated Products Gallery — a "hero-strip" of the strongest AI stills
export const GALLERY = [
  { key: "paperCups", src: P.paperCups, caption: "Kraft Paper Cups", ref: "01·02" },
  { key: "kraftTakeaway", src: P.kraftTakeaway, caption: "Kraft Takeaway Boxes", ref: "01·06" },
  { key: "paperCupsWhite", src: P.paperCupsWhite, caption: "White Paper Cups", ref: "01·12" },
  { key: "kraftBowl", src: P.kraftBowl, caption: "Kraft Bowls & Lids", ref: "01·05" },
  { key: "kraftContainer", src: P.kraftContainer, caption: "Kraft Containers", ref: "01·03" },
  { key: "paperBag", src: P.paperBag, caption: "Paper Carry Bags", ref: "01·08" },
  { key: "sandwichBox", src: P.sandwichBox, caption: "Sandwich Boxes", ref: "01·04" },
  { key: "sosBag", src: P.sosBag, caption: "SOS Paper Bags", ref: "01·10" },
  { key: "aluminiumContainer", src: P.aluminiumContainer, caption: "Aluminium Containers", ref: "02·16" },
  { key: "aluminiumFoil", src: P.aluminiumFoil, caption: "Aluminium Foil", ref: "02·15" },
  { key: "woodenCutlery", src: P.woodenCutlery, caption: "Birch-Wood Cutlery", ref: "03·20" },
  { key: "hygieneGloves", src: P.hygieneGloves, caption: "Disposable Gloves", ref: "04·22" },
  { key: "hygieneMasks", src: P.hygieneMasks, caption: "Face Masks", ref: "04·23" },
  { key: "plasticMicrowave", src: P.plasticMicrowave, caption: "Microwave Containers", ref: "05·29" },
  { key: "plasticClear", src: P.plasticClear, caption: "Clear Containers", ref: "05·28" },
];

export const MANIFESTO = [
  {
    n: "01",
    title: "Sourced with intention.",
    body:
      "Every fibre, foil and film is chosen for its origin, its footprint and its finish. We refuse the shortcut of anonymous supply.",
  },
  {
    n: "02",
    title: "Engineered to endure the meal.",
    body:
      "Packaging must hold, insulate, and disappear quietly. Nothing more. We tune each product for the exact life it must lead.",
  },
  {
    n: "03",
    title: "Designed to leave nothing behind.",
    body:
      "Kraft, birch, aluminium, recyclable resins. Materials chosen so the last stop is compost, recycling, or a second life — not landfill.",
  },
  {
    n: "04",
    title: "Delivered from Ajman, across the region.",
    body:
      "From our Free Zone base in Ajman, UAE, we ship in full container loads and small runs to restaurants, cloud kitchens, retailers and institutions across the GCC, Africa and the Subcontinent.",
  },
];
